module.exports = __webpack_public_path__ + "img/login-1.46a1a536.jpg";